// Distinct, on-brand default covers for churches without an uploaded photo.
// Each theme is a warm/earthy or faith-toned gradient. When a church has no
// explicit `cover_theme`, one is derived deterministically from its id/name so
// every card stays visually distinct instead of sharing one generic image.

export const COVER_THEMES = [
  { key: "terracotta", label: "Terracotta", gradient: "linear-gradient(135deg,#E08A63,#B85C3C)" },
  { key: "navy", label: "Marine", gradient: "linear-gradient(135deg,#1E4038,#0E211D)" },
  { key: "gold", label: "Or", gradient: "linear-gradient(135deg,#E7B04A,#B9822A)" },
  { key: "plum", label: "Prune", gradient: "linear-gradient(135deg,#7A4468,#452740)" },
  { key: "emerald", label: "Émeraude", gradient: "linear-gradient(135deg,#2E8C77,#12463C)" },
  { key: "indigo", label: "Indigo", gradient: "linear-gradient(135deg,#465AA0,#232E56)" },
  { key: "rose", label: "Rose", gradient: "linear-gradient(135deg,#CE6577,#8F384A)" },
  { key: "sky", label: "Ciel", gradient: "linear-gradient(135deg,#4E90B8,#245B7A)" },
];

const hashStr = (s = "") => {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return h;
};

export const coverThemeFor = (church) => {
  const key = church?.cover_theme;
  if (key) {
    const found = COVER_THEMES.find((t) => t.key === key);
    if (found) return found;
  }
  const seed = church?.id || church?.name || "";
  return COVER_THEMES[hashStr(String(seed)) % COVER_THEMES.length];
};
